var app = angular.module("leonardo");

var WorkOrderList = function($scope, ngDialog, WorkOrderService, PermissionService, FilterService, $controller, AnalyticsService, StatsigService, WorkOrderProviderService, AuthDataService) {

  $scope.permissionService = PermissionService;
  $scope.workOrderService = WorkOrderService;

  $scope.isValidStatus = function (workOrder) {
    const status = workOrder ? workOrder.status : null;
    return status ? !['Cancelled', 'Completed'].includes(status) : true;
  };

  $scope.showWorkOrderDetail = function(work_order) {
    AnalyticsService.track('Task opened', {
      context: 'work orders',
      destination: 'detail',
      entry_method: 'click',
      ...AnalyticsService.getTaskGroupProperties(work_order)});
    work_order.getTriggerData().then(function (result) {
      ngDialog.open({
        template: 'views/templates/dialog/work-order/detail.html',
        controller: 'WorkOrderDetailsDialog',
        data: {
          work_order: result,
        }
      });
    });
  };

  $scope.showResolveDialog = function (work_order) {
    AnalyticsService.track('Task Opened', {
      context: 'work orders',
      destination: 'complete',
      entry_method: 'click',
      ...AnalyticsService.getTaskGroupProperties(work_order)});
    WorkOrderService.get(work_order.id).then(function (workOrder) {
      ngDialog.open({
        template: 'views/templates/dialog/work-order/resolve.html',
        controller: 'WorkOrderResolveDialog',
        data: {
          work_order: workOrder
        }
      });
    });
  };

  $scope.showEdit = async function (work_order) {
    var didActivateGate = false;
    function cleanupGate() {
      if (didActivateGate) {
        StatsigService.deactivateContextualGate('work_orders_new_experience');
        didActivateGate = false;
      }
    }
    try {
      var inIframe = false;
      try {
        inIframe = window.self !== window.top;
      } catch (e) {
        inIframe = true;
      }

      const useNewExperience = inIframe ? true : await StatsigService.checkGate('work_orders_new_experience');

      if (!inIframe && useNewExperience) {
        StatsigService.activateContextualGate('work_orders_new_experience');
        didActivateGate = true;
      }
      
      AnalyticsService.track('Work Order Opened', {
        ...AnalyticsService.getWorkOrderGroupProperties(work_order),
        portfolio_id: FilterService.currentPortfolio ? FilterService.currentPortfolio.id : null,
        uses_new_experience: useNewExperience,
        work_order_id: work_order.id
      });
      
      if (useNewExperience) {
        // New Expo experience
        WorkOrderService.get(work_order.id).then(function (result) {
          WorkOrderProviderService.openWorkOrder({
            useExpoIntegration: true,
            action: 'edit',
            workOrderId: work_order.id,
            workOrderObj: result,
            data: {
              work_order: result,
              property: result.property,
              account: result.account
            },
            closeCallback: function(result) {
              cleanupGate();
              if (result) {
                $scope.loadPage($scope.page);
              }
            }
          }).catch(function() {
            cleanupGate();
          });
        });
      } else {
        // Legacy experience
        WorkOrderService.get(work_order.id).then(function (result) {
          ngDialog.openConfirm({
            template: 'views/templates/dialog/work-order/form.html',
            className: 'ngdialog-theme-default ngdialog-template-edit',
            controller: 'WorkOrderDialogForm',
            data: {
              work_order: result,
              action: 'edit',
            }
          }).then(function(){
            $scope.loadPage($scope.page);
          });
        });
      }
    } catch (error) {
      console.error('[WORK_ORDER] Failed to open work order for edit:', error);
      cleanupGate();
    }
  };

  $scope.getEntitiesPromise = function(options) {
    options['summary'] = true;
    options['account'] = FilterService.getFilter('account_reports');
    options['group'] = FilterService.getFilter('group_reports');
    options['portfolio'] = FilterService.getFilter('portfolio_reports');
    options['property'] = FilterService.getFilter('property_reports');
    options['pms_platform'] = FilterService.getFilter('pms_platform');
    options['status'] = FilterService.getFilter('status');
    options['type'] = FilterService.getFilter('type');
    options['unit_number'] = FilterService.getFilter('unit');
    options['priority'] = FilterService.getFilter('priority');
    options['category'] = FilterService.getFilter('category');
    options['name'] = FilterService.getFilter('name');
    options['external_id'] = FilterService.getFilter('external_id');
    options['due_date'] = FilterService.getFilter('due_date');
    options['from_date'] = FilterService.getFilter('from_date');
    options['to_date'] = FilterService.getFilter('to_date');
    options['date_range'] = FilterService.getFilter('date_range');
    options['completed_date'] = FilterService.getFilter('completed_date');
    options['service_request_date'] = FilterService.getFilter('service_request_date');
    options['building'] = FilterService.getFilter('building_number');
    options['account_users_assigned'] = FilterService.getFilter('account_users_assigned');
    options['last_modified_by'] = FilterService.getFilter('last_modified_by');
    options['exclude_completed'] = FilterService.getFilter('exclude_completed');
    options['created_from_date'] = FilterService.getFilter('created_from_date');
    options['created_to_date'] = FilterService.getFilter('created_to_date');
    options['created_date_range'] = FilterService.getFilter('created_date_range');

    if (FilterService.getFilter('origin') === "leo") {
      options['origin_leo'] = true;
    }
    if (FilterService.getFilter('origin') === "latchel") {
      options['is_latchel'] = true;
    }
    if (FilterService.getFilter('origin') === "pms") {
      options['origin_leo'] = false;
    }

    return WorkOrderService.getlist(options);
  };

  $scope.showItemDeleteDialog = function(workOrder) {
    WorkOrderService.get(workOrder.id).then(function(data) {
      ngDialog.openConfirm({
        template: 'views/templates/dialog/delete.html',
        controller: 'DeleteDialog',
        data: {
          object: data,
          type: 'work order'
        }
      }).then(function(){
        $scope.loadPage($scope.page);
      });
    });
  };

  $scope.$on('work-order:updated', function() {
    $scope.loadPage($scope.page);
  });
  $scope.$on('work-order:created', function() {
    $scope.loadPage($scope.page);
  });
  $scope.$on('work-order:deleted', function() {
    $scope.loadPage($scope.page);
  });

  $controller('TableFilterController', {$scope: $scope});

  $scope.loadPage(1);
};

app.controller('WorkOrderList', ['$scope', 'ngDialog', 'WorkOrderService', 'PermissionService', 'FilterService',
  '$controller', 'AnalyticsService', 'StatsigService', 'WorkOrderProviderService', 'AuthDataService', WorkOrderList]);
